import React, { useEffect, useState } from "react";
import Modal from 'react-modal';
import './AdminLeaveTable.css';
import { format } from 'date-fns';
import { getApprovedLeaves, getLeaves, rejectLeave, updateLeavesApprove } from "../../../services/leaveService";
import { getAuditLog } from "../../../utils/calculateDaysInMonthUtils";

// Set the app element for accessibility (do this in your root app file or here)
Modal.setAppElement('#root');

const AdminLeaveTable = () => {
  const [leaveList, setLeaveList] = useState([]);
  const [error, setError] = useState(null);
  const [approvedLeaves, setApprovedLeaves] = useState([]);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [currentLeave, setCurrentLeave] = useState(null);
  const [remark, setRemark] = useState('');

  const employeeId = localStorage.getItem('employeeId');
  const employeeUniqueId = localStorage.getItem('employeeUniqueIdLogin');
  const role = localStorage.getItem('role');

  const fetchLeaves = async () => {
    // Check if we actually have the data before calling the API
    if (!employeeUniqueId || !role) {
      console.warn("Skipping fetchLeaves: employeeUniqueId or role is missing");
      return;
    }

    try {
      const data = await getLeaves(employeeUniqueId, role);
      setLeaveList(data);
    } catch (error) {
      setError("Error fetching leaves.");
      console.error("Error fetching leaves:", error);
    }
  };

  const fetchApprovedLeaves = async () => {
    try {
      const data = await getApprovedLeaves(employeeId);
      setApprovedLeaves(data);
    } catch (err) {
      console.error('Error fetching approved leaves:', err);
    }
  };

  useEffect(() => {
    fetchLeaves();
    fetchApprovedLeaves();
  }, []);

  const handleStatusUpdate = async (leave, newStatus) => {
    const confirmMessage = `Are you sure you want to ${newStatus.toLowerCase()} this leave request?`;
    const isConfirmed = window.confirm(confirmMessage);

    if (!isConfirmed) return;

    if (newStatus === "Denied") {
      // Open modal for remark input
      setCurrentLeave(leave);
      setIsModalOpen(true);
     // fetchApprovedLeaves();
     // fetchLeaves();
      //getLeaves();
      return;
    }

    try {
      const payload = {
        leaveId: leave.id,
        auditlog: getAuditLog(),
      };

      if (newStatus === "Approved") {
        await updateLeavesApprove(payload);
        const updatedLeave = { ...leave, status: newStatus };
        setLeaveList((prev) => prev.filter((l) => l.id !== leave.id));
        setApprovedLeaves((prev) => {
          const exists = prev.find((l) => l.id === leave.id);
          if (exists) {
            return prev.map((l) => (l.id === leave.id ? updatedLeave : l));
          }
          return [...prev, updatedLeave];
        });

        alert("Leave Updated Successfully");
        fetchLeaves();
        fetchApprovedLeaves();
       // getLeaves();

      }
    } catch (error) {
      const errorMessage = error?.response?.data?.error || "An unknown error occurred.";
      setError(errorMessage);
      alert(errorMessage);
    }
  };

  const handleDenySubmit = async () => {
    if (!remark.trim()) {
      alert("Remark cannot be empty.");
      return;
    }

    try {
      const payload = {
        leaveId: currentLeave.id,
        auditlog: getAuditLog(),
        remark,
      };

      await rejectLeave(payload);

      setLeaveList((prevLeaves) =>
        prevLeaves.map((l) =>
          l.id === currentLeave.id ? { ...l, status: "Denied", remark } : l
        )
      );

      alert("Leave Denied Successfully");
      setIsModalOpen(false);
      setRemark('');
      fetchLeaves();
      fetchApprovedLeaves();
      //getLeaves();
      setCurrentLeave(null);
    } catch (error) {
      const errorMessage = error?.response?.data?.error || "An unknown error occurred.";
      setError(errorMessage);
      alert(errorMessage);
    }
  };

  const closeModal = () => {
    setIsModalOpen(false);
    setRemark('');
    setCurrentLeave(null);
  };

  return (
    <React.Fragment>
      <div className="adminleavetable-main">
        <h3 className="adminleavetable-heading">Leave Request List</h3>
        <div className="adminleave-table">
          <table className="adminleavemanagement-table">
            <thead>
              <tr>
                {/* <th>S.no</th>
                <th>Emp Id</th> */}
                <th>Employee Name</th>
                <th>From Date</th>
                <th>To Date</th>
                <th>No of Days</th>
                <th>Leave Type</th>
                <th>Reason</th>

                <th>Status</th>
                {/* <th>Remark</th> */}
              </tr>
            </thead>
            <tbody>
              {leaveList.length > 0 ? (
                leaveList.map((leave, index) => (
                  <tr key={index}>
                    {/* <td>{index + 1}</td>
                    <td>{leave.employeeId}</td> */}
                    <td>{leave.employeeName}</td>
                    <td>{format(new Date(leave.fromDate), 'dd-MM-yyyy')}</td>
                    <td>{format(new Date(leave.toDate), 'dd-MM-yyyy')}</td>
                    <td>{leave.daysApplied}</td>
                    <td>{leave.type}</td>
                    <td>{leave.reason}</td>

                    <td style={{ display: 'flex', justifyContent: 'space-evenly' }}>
                      {/* {leave.status === 'Approved' ? (
                        <span className="status-text approved">Approved</span>
                      ) : leave.status === 'Denied' ? (
                        <span className="status-text denied">Denied</span>
                      ) : ( */}
                      <>
                        <button
                          className="button-approve"
                          onClick={() => handleStatusUpdate(leave, 'Approved')}
                        >
                          Approve
                        </button>
                        <button
                          className="button-deny"
                          onClick={() => handleStatusUpdate(leave, 'Denied')}
                        >
                          Deny
                        </button>
                      </>
                      {/* )} */}
                    </td>
                    {/* <td>{leave.remark || '-'}</td> */}
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="9" style={{ textAlign: 'center' }}>No leave requests found.</td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
        {error && <div className="error-message">{error}</div>}
      </div>

      {approvedLeaves.length > 0 && (
        <div className="adminleavetable-main">
          <h3 className="adminleavetable-heading">Approved/Rejected Leaves</h3>
          <div className="adminleave-table">
            <table className="adminleavemanagement-table">
              <thead>
                <tr>
                  {/* <th>ID</th>
                  <th>Employee ID</th> */}
                  <th>Employee Name</th>
                  <th>From Date</th>
                  <th>To Date</th>
                  <th>No of Days</th>
                  <th>Leave Type</th>
                  <th>Reason</th>
                  <th>Status</th>
                </tr>
              </thead>
              <tbody>
                {approvedLeaves.map((leave, index) => (
                  <tr key={index}>
                    {/* <td>{index+1}</td>
                    <td>{leave.employeeId}</td> */}
                    <td>{leave.employeeName}</td>
                    <td>{format(leave.fromDate, 'dd-MM-yyyy')}</td>
                    <td>{format(leave.toDate, 'dd-MM-yyyy')}</td>
                    <td>{leave.daysApplied}</td>
                    <td>{leave.type}</td>
                    <td>{leave.reason}</td>
                    <td>{leave.status}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      )}


      {/* Modal for entering deny remark */}
      <Modal
        isOpen={isModalOpen}
        onRequestClose={closeModal}
        className="modal-content"
        overlayClassName="modal-overlay"
        contentLabel="Deny Leave Remark"
      >
        <h2 className="modal-heading">Deny Leave Request</h2>
        <p>Please enter the reason for denying this leave request:</p>
        <textarea
          className="modal-textarea"
          value={remark}
          onChange={(e) => setRemark(e.target.value)}
          placeholder="Enter remark"
          rows="4"
        />
        <div className="modal-buttons">
          <button className="modal-button modal-button-submit" onClick={handleDenySubmit}>
            Submit
          </button>
          <button className="modal-button modal-button-cancel" onClick={closeModal}>
            Cancel
          </button>
        </div>
      </Modal>
    </React.Fragment>
  );
};

export default AdminLeaveTable;